import type { ApiToken, ApiTokenRequest, CreatedApiToken } from '@/types';
import type { AxiosInstance, AxiosResponse } from 'axios';

class TokenService {
    private readonly apiService;

    constructor(apiService: AxiosInstance) {
        this.apiService = apiService;
    }

    getPath(id?: number | string) {
        return id ? `/api/tokens/${id}` : '/api/tokens';
    }

    index(): Promise<AxiosResponse<{ data: ApiToken[] }>> {
        return this.apiService.get(this.getPath());
    }

    store(request: ApiTokenRequest): Promise<AxiosResponse<{ data: CreatedApiToken }>> {
        return this.apiService.post(this.getPath(), request);
    }

    destroy(id: number | string) {
        return this.apiService.delete(this.getPath(id));
    }
}

export default TokenService;
